import { render } from "./SettingsNavigation.vue?vue&type=template&id=05223bde&scoped=true"
import script from "./SettingsNavigation.vue?vue&type=script&lang=js"
export * from "./SettingsNavigation.vue?vue&type=script&lang=js"

import "./SettingsNavigation.vue?vue&type=style&index=0&id=05223bde&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05223bde"]])

export default __exports__